import {
  DuplexMode,
  FrequencyRange,
  FRONTHAUL_TYPE_CONFIG,
  FronthaulType,
  RanMode,
  Tenant,
} from "@allbesmart/web-app-common";
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormArray, ReactiveFormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import { GnbInstanceConfigurationFormGroup } from "../../../models/gnb-instance-config-form-group.model";

interface InstanceColumn {
  label: string;
  control: GnbInstanceConfigurationFormGroup;
  isRadio: boolean;
}

@Component({
    selector: "oaibox-gnb-instance-config-table",
    templateUrl: "./gnb-instance-config-table.component.html",
    styleUrls: ["./gnb-instance-config-table.component.css"],
    imports: [ReactiveFormsModule],
})
export class GnbInstanceConfigTableComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input({ required: true })
  gnbs!: FormArray<GnbInstanceConfigurationFormGroup>;
  @Input({ required: true }) dus!: FormArray<GnbInstanceConfigurationFormGroup>;
  @Input({ required: true }) cus!: FormArray<GnbInstanceConfigurationFormGroup>;
  @Input({ required: true })
  cusCP!: FormArray<GnbInstanceConfigurationFormGroup>;
  @Input({ required: true })
  cusUP!: FormArray<GnbInstanceConfigurationFormGroup>;
  @Input() tenant?: Tenant;
  @Input() showRanStack = true;

  protected readonly FRONTHAUL_TYPE_CONFIG = FRONTHAUL_TYPE_CONFIG;
  protected readonly AVAILABLE_FRONTHAUL_TYPES: FronthaulType[] =
    Object.values(FronthaulType);
  protected readonly AVAILABLE_FREQUENCY_RANGES: FrequencyRange[] =
    Object.values(FrequencyRange);
  protected readonly AVAILABLE_DUPLEX_MODES: DuplexMode[] =
    Object.values(DuplexMode);
  protected readonly AVAILABLE_RAN_MODES: RanMode[] = Object.values(RanMode);

  protected columns: InstanceColumn[] = [];
  protected showRanStackRow = false;

  private readonly subscriptions = new Subscription();

  ngOnInit(): void {
    this.refresh();
    for (const array of [
      this.gnbs,
      this.dus,
      this.cus,
      this.cusCP,
      this.cusUP,
    ]) {
      this.subscriptions.add(
        array.valueChanges.subscribe(() => this.refresh())
      );
    }
  }

  ngOnChanges(): void {
    this.refresh();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private refresh(): void {
    this.showRanStackRow = this.showRanStack && (this.tenant?.multiRan ?? false);
    this.columns = [
      ...this.gnbs.controls.map((control, i) => ({
        label: `gNB #${i + 1}`,
        control,
        isRadio: true,
      })),
      ...this.dus.controls.map((control, i) => ({
        label: `DU #${i + 1}`,
        control,
        isRadio: true,
      })),
      ...this.cus.controls.map((control, i) => ({
        label: `CU #${i + 1}`,
        control,
        isRadio: false,
      })),
      ...this.cusCP.controls.map((control, i) => ({
        label: `CU-CP #${i + 1}`,
        control,
        isRadio: false,
      })),
      ...this.cusUP.controls.map((control, i) => ({
        label: `CU-UP #${i + 1}`,
        control,
        isRadio: false,
      })),
    ];
  }
}
